export default __webpack_public_path__ + "static/media/remittance.f4d0e5e7.svg";